const SideMenuState: SideMenuState = {
  activePath: '/dashboard',
};

export default SideMenuState;
